import { getSelectedConfiguration as getSelectedConfigurationFromDraft } from '@/model/draft/getSelectedConfiguration';
import { StoreState } from '@/redux/types';
import { getDraft } from './getDraft';

export const getSelectedConfiguration = (state: StoreState) =>
  getSelectedConfigurationFromDraft(getDraft(state));
